import { useCallback } from 'react'

export function useResizeDrag({
  cssVar,
  direction,
  minWidth,
  maxWidth,
  onResizeEnd,
}: {
  cssVar: string
  direction: 'right' | 'left'
  minWidth: number
  maxWidth: number
  onResizeEnd: (width: number) => void
}) {
  return useCallback(
    (e: React.MouseEvent, currentWidth: number) => {
      e.preventDefault()
      const startX = e.clientX
      const startWidth = currentWidth

      document.documentElement.classList.add('app-resizing')
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'

      const clamp = (val: number) => Math.max(minWidth, Math.min(maxWidth, val))

      const onMouseMove = (ev: MouseEvent) => {
        const delta = direction === 'right' ? ev.clientX - startX : startX - ev.clientX
        document.documentElement.style.setProperty(cssVar, `${clamp(startWidth + delta)}px`)
      }

      const onMouseUp = (ev: MouseEvent) => {
        const delta = direction === 'right' ? ev.clientX - startX : startX - ev.clientX
        onResizeEnd(clamp(startWidth + delta))
        document.documentElement.classList.remove('app-resizing')
        document.body.style.cursor = ''
        document.body.style.userSelect = ''
        document.removeEventListener('mousemove', onMouseMove)
        document.removeEventListener('mouseup', onMouseUp)
      }

      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
    },
    [cssVar, direction, minWidth, maxWidth, onResizeEnd],
  )
}
